export default {
  SET_ACTIONSETS: 'setActionsets',
  SET_SELECTED_ACTIONSET: 'setSelectedActionset',
  SET_FIELD_TENANTS: 'setFieldTenants',
  SET_FIELD_ACTIONS: 'setFieldActions'
}